import React, { useState } from 'react';
import { 
  Settings as SettingsIcon, 
  User, 
  Shield, 
  Database,
  Info,
  Save
} from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';

const Settings = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('profile');

  const tabs = [
    { id: 'profile', name: 'Perfil', icon: User },
    { id: 'security', name: 'Segurança', icon: Shield },
    { id: 'system', name: 'Sistema', icon: Database },
    { id: 'about', name: 'Sobre', icon: Info }
  ];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Configurações</h1>
        <p className="mt-2 text-gray-600">
          Gerencie suas configurações e preferências
        </p>
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`py-2 px-1 border-b-2 font-medium text-sm flex items-center ${
                activeTab === tab.id
                  ? 'border-primary-500 text-primary-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <tab.icon className="h-4 w-4 mr-2" />
              {tab.name}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab de perfil */}
      {activeTab === 'profile' && (
        <div className="card">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Informações do Perfil</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Nome de Usuário
              </label>
              <input
                type="text"
                value={user?.username || ''}
                disabled
                className="input-field bg-gray-50"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Email
              </label>
              <input
                type="email"
                value={user?.email || 'admin@whatsapp-service.com'}
                disabled
                className="input-field bg-gray-50"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Nome Completo
              </label>
              <input
                type="text"
                value={user?.fullName || 'Administrador do Sistema'}
                disabled
                className="input-field bg-gray-50"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Função
              </label>
              <input
                type="text"
                value="Administrador"
                disabled
                className="input-field bg-gray-50"
              />
            </div>
          </div>
          <div className="mt-6">
            <button className="btn-secondary" disabled>
              <Save className="h-4 w-4 mr-2" />
              Editar Perfil (Em breve)
            </button>
          </div>
        </div>
      )}

      {/* Tab de segurança */}
      {activeTab === 'security' && (
        <div className="card">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Configurações de Segurança</h3>
          <div className="space-y-4">
            <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
              <div>
                <h4 className="font-medium text-gray-900">Autenticação de Dois Fatores</h4>
                <p className="text-sm text-gray-500">Adicione uma camada extra de segurança</p>
              </div>
              <button className="btn-secondary" disabled>
                Ativar (Em breve)
              </button>
            </div>
            
            <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
              <div>
                <h4 className="font-medium text-gray-900">Sessões Ativas</h4>
                <p className="text-sm text-gray-500">Gerencie suas sessões de login</p>
              </div>
              <button className="btn-secondary" disabled>
                Gerenciar (Em breve)
              </button>
            </div>
            
            <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
              <div>
                <h4 className="font-medium text-gray-900">Histórico de Login</h4>
                <p className="text-sm text-gray-500">Visualize tentativas de acesso</p>
              </div>
              <button className="btn-secondary" disabled>
                Visualizar (Em breve)
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Tab de sistema */}
      {activeTab === 'system' && (
        <div className="card">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Configurações do Sistema</h3>
          <div className="space-y-4">
            <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
              <div>
                <h4 className="font-medium text-gray-900">Notificações</h4>
                <p className="text-sm text-gray-500">Configure alertas e notificações</p>
              </div>
              <button className="btn-secondary" disabled>
                Configurar (Em breve)
              </button>
            </div>
            
            <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
              <div>
                <h4 className="font-medium text-gray-900">Backup e Restauração</h4>
                <p className="text-sm text-gray-500">Gerencie backups do sistema</p>
              </div>
              <button className="btn-secondary" disabled>
                Gerenciar (Em breve)
              </button>
            </div>
            
            <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
              <div>
                <h4 className="font-medium text-gray-900">Logs do Sistema</h4>
                <p className="text-sm text-gray-500">Visualize logs de atividade</p>
              </div>
              <button className="btn-secondary" disabled>
                Visualizar (Em breve)
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Tab sobre */}
      {activeTab === 'about' && (
        <div className="card">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Sobre o Sistema</h3>
          <div className="space-y-4">
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <h4 className="font-medium text-blue-900 mb-2">WhatsApp Service</h4>
              <p className="text-sm text-blue-800">
                Sistema de gerenciamento e envio de mensagens via WhatsApp através de uma API REST.
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <h4 className="font-medium text-gray-900 mb-2">Versão</h4>
                <p className="text-sm text-gray-600">1.0.0</p>
              </div>
              <div>
                <h4 className="font-medium text-gray-900 mb-2">Desenvolvedor</h4>
                <p className="text-sm text-gray-600">Henrique Rego</p>
              </div>
              <div>
                <h4 className="font-medium text-gray-900 mb-2">Tecnologias</h4>
                <p className="text-sm text-gray-600">Node.js, React, WhatsApp Web.js</p>
              </div>
              <div>
                <h4 className="font-medium text-gray-900 mb-2">Licença</h4>
                <p className="text-sm text-gray-600">ISC</p>
              </div>
            </div>
            
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
              <h4 className="font-medium text-gray-900 mb-2">Funcionalidades Principais</h4>
              <ul className="list-disc list-inside space-y-1 text-sm text-gray-700">
                <li>Envio de mensagens de texto e mídia</li>
                <li>Verificação de números do WhatsApp</li>
                <li>Gerenciamento de conexões</li>
                <li>Interface web responsiva</li>
                <li>Sistema de autenticação seguro</li>
                <li>API REST completa</li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Settings;

